import { Divider, Flex, Text } from '@mantine/core';
import { forwardRef } from 'react';

// This interface defines the props our custom item will receive from the Select component.
// We add 'location' as a custom property.
interface CustomSelectItemProps extends React.ComponentPropsWithoutRef<'div'> {
  label: string;
  state?: string;
  city?: string;
}

export const CustomSelectItem = forwardRef<HTMLDivElement, CustomSelectItemProps>(
  ({ label, state, city, ...others }: CustomSelectItemProps, ref) => {
    return (
      // The 'ref' is passed to the main div for Mantine's internal management.
      <div
        ref={ref}
        {...others}
      >
        <Flex
          justify="space-between"
          align="center"
          py={16}
        >
          <Text
            fw={700}
            c="primary.0"
            fz="md"
          >
            {label}
          </Text>
          {state && city && (
            <Text
              fz="xs"
              c="primary.1"
              fw={400}
            >
              {`${city},${state}`}
            </Text>
          )}
        </Flex>
        <Divider color="neutral.4" />
      </div>
    );
  },
);

CustomSelectItem.displayName = 'CustomSelectItem';
